import { Fragment, isValidElement, ReactNode, useMemo } from 'react'
import { WalletReadyState } from '@tronweb3/tronwallet-abstract-adapter'
import { useAppkit } from './hooks'
import { Status } from './tron'

export function TronDialog() {
  const { getSnapshot, setOpen, connectByAdapter } = useAppkit()
  const { adapters, isOpen, status } = getSnapshot()

  const _adapters = useMemo(
    () => adapters.filter(v => v.readyState === WalletReadyState.Found),
    [adapters]
  )

  const goInstallWallet = () => {
    adapters.find(v => v.name === 'TronLink')?.connect()
    setOpen(false)
  }

  return (
    <Dialog
      open={isOpen}
      onOpenChange={setOpen}
      header="Connect a wallet on Tron to continue">
      <div className="flex flex-col gap-2">
        {_adapters.map(v => (
          <button
            className="btn flex gap-2"
            key={v.name}
            onClick={() => connectByAdapter(v)}
            disabled={status === Status.Connecting}>
            <span>{v.name}</span>
            <span className="flex-1 text-start font-light opacity-60">
              {v.readyState === WalletReadyState.Found && 'Installed'}
            </span>
            <img src={v.icon} alt={v.name} className="h-6 w-6" />
          </button>
        ))}
        {!_adapters.length && (
          <button className="btn" onClick={goInstallWallet}>
            Get Tron Wallet
          </button>
        )}
      </div>
    </Dialog>
  )
}

type DialogOutput = 'ok' | 'cancel' | (unknown & {})

function Dialog({
  open,
  onOpenChange,
  onClose,
  header,
  children,
  actions
}: {
  open: boolean
  onOpenChange?(open: boolean): void
  onClose?(output: DialogOutput): void
  header?: ReactNode
  children?: ReactNode
  actions?: {
    children: ReactNode
    output?: DialogOutput | (() => DialogOutput)
  }[]
}) {
  const close = (output: DialogOutput) => {
    onOpenChange?.(false)
    onClose?.(output)
  }

  return (
    <dialog
      open={open}
      className="modal modal-bottom sm:modal-middle"
      onClose={() => close('ok')}
      onCancel={() => close('cancel')}>
      <div className="modal-box">
        <form method="dialog">
          <button
            className="btn btn-sm btn-circle btn-ghost absolute top-2 right-2"
            onClick={() => close('cancel')}>
            ✕
          </button>
        </form>

        {isValidElement(header) ? (
          header
        ) : (
          <h3 className="text-lg font-bold">{header}</h3>
        )}

        <div className="py-4">{children}</div>

        {actions?.length && (
          <div className="modal-action">
            {actions?.map((v, i) => (
              <Fragment key={i}>
                {isValidElement(v.children) ? (
                  v.children
                ) : (
                  <form method="dialog">
                    <button
                      className="btn"
                      onClick={
                        'output' in v &&
                        v.output !== 'ok' &&
                        v.output !== undefined
                          ? () =>
                              close(
                                typeof v.output === 'function'
                                  ? v.output()
                                  : v.output
                              )
                          : undefined
                      }>
                      {v.children}
                    </button>
                  </form>
                )}
              </Fragment>
            ))}
          </div>
        )}
      </div>
      <form method="dialog" className="modal-backdrop">
        <button onClick={() => close('cancel')}>close</button>
      </form>
    </dialog>
  )
}
